import httpClient from './httpClient'

export const signUp = async (payload) => {
  const endpoint = '/refusers/create'
  return httpClient.post(endpoint, payload)
}

export const activateAccount = async (payload) => {
  const endpoint = '/refusers/updateUserFromActivationGuid'
  return httpClient.put(endpoint, { ActivationGuid: payload.guid})
}

export const resendActivationAccountLink = async (payload) => {
  const endpoint = '/refusers/resendActivation'
  return httpClient.post(endpoint, { Email: payload})
}

export default {
  signUp,
  activateAccount,
  resendActivationAccountLink,
}
